<template>
    <span
        v-if="publishGateEnabled"
        class="question-badge"
        :class="required ? 'question-badge--required' : 'question-badge--recommended'"
    >
        {{ required ? 'Required to publish' : 'Recommended' }}
    </span>
</template>

<script>
export default {
    name: 'QuestionBadge',
    props: {
        publishGateEnabled: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.question-badge {
    display: inline-block;
    padding: 0.15rem 0.65rem;
    border-radius: 999px;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-left: 0.5rem;
    vertical-align: middle;
    white-space: nowrap;
}
.question-badge--required {
    background: #ccfbf1;
    color: #0f766e;
}
.question-badge--recommended {
    background: #e2e8f0;
    color: #475569;
}
</style>
